import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col } from "antd";
import Reviewimg from "../../Images/review.png";
import headphones from "../../Images/headphones.png";

class Review extends Component {
  render() {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    return (
      <div>
        <Row style={{ textAlign: "center", padding: "50px" }}>
          <img src={Reviewimg} alt="" />
          {orgDetails["approvalStatus"] === "F" ? (
            <h3
              className="Docheading"
              style={{
                fontSize: "30px",
                lineHeight: "30px",
                paddingTop: "40px",
              }}
            >
              Your account is currently frozen. Kindly contact your sales
              representative for more details.
            </h3>
          ) : orgDetails["approvalStatus"] === "D" ? (
            <>
              <h3
                className="Docheading"
                style={{
                  fontSize: "30px",
                  lineHeight: "30px",
                  paddingTop: "40px",
                }}
              >
                Your Account is rejected{" "}
              </h3>
              <p
                className="Docpara"
                style={{ fontSize: "17px", color: "#7B8190" }}
              >
                You will be notified via email once your profile is approved.
              </p>
            </>
          ) : (
            <>
              <h3
                className="Docheading"
                style={{
                  fontSize: "30px",
                  lineHeight: "30px",
                  paddingTop: "40px",
                }}
              >
                Your profile is Inactive
              </h3>
              <p
                className="Docpara"
                style={{ fontSize: "17px", color: "#7B8190" }}
              >
                You will be notified via email once your profile is active.
              </p>
            </>
          )}
        </Row>
        <Row style={{ marginTop: "4%" }}>
          {/* <Col lg={12} md={12} sm={24} xs={24}>
            <div style={{width:'500px',backgroundColor:'white', padding:'20px', borderRadius: '10px'}}>
               <Row>
                 <Col lg={8} md={8} sm={24} xs={24}>
                   <div className="Faqdiv">
                    <img src={conversation} alt="" />
                    </div>
                 </Col>
                 <Col lg={16} md={16} sm={24} xs={24}>
                    <h3  className="Docheading"style={{fontSize:'30px', lineHeight:'30px', paddingTop:'40px'}} >FAQ</h3>
                    <p className="Docpara" style={{fontSize:'17px', color:'#7B8190'}}>Maybe we’ve already answered your question. Here’s our FAQs</p>
                 </Col>
               </Row>
            </div>
          </Col> */}
          <Col lg={24} md={24} sm={24} xs={24}>
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <Row>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <div className="Faqdiv">
                    <img src={headphones} alt="" />
                  </div>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <h3
                    className="Docheading"
                    style={{
                      fontSize: "30px",
                      lineHeight: "30px",
                      paddingTop: "40px",
                    }}
                  >
                    Contact Us
                  </h3>
                  <p
                    className="Docpara"
                    style={{ fontSize: "17px", color: "#7B8190" }}
                  >
                    Please contact us at{" "}
                    <a href="mailto:office@defeomaterials.com">
                      office@defeomaterials.com
                    </a>{" "}
                    for any further queries.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Review;
